export default () => {
  const addButton = document.getElementById('add_multi_option')
  const wrapper = document.getElementById('multi_option_wrapper')
  const templateElem = document.getElementById('multi_option_template')
  const template = templateElem ? templateElem.innerHTML : ''

  if (!addButton || !wrapper || !template) {
    // Required elements are not present, do not initialize
    return
  }

  let index = Date.now()

  addButton.addEventListener('click', function (e) {
    e.preventDefault()
    const newField = template.replace(/INDEX/g, index)
    wrapper.insertAdjacentHTML('beforeend', newField)
    index++
  })

  wrapper.addEventListener('click', function (e) {
    if (e.target.parentElement &&
      e.target.parentElement.classList.contains('remove_multi_option')) {
      e.preventDefault()
      const fieldWrapper = e.target.parentElement.closest('.nested-fields')
      if (fieldWrapper) {
        const destroyInput = fieldWrapper.querySelector('input[type="hidden"][name*="_destroy"]')
        if (destroyInput) destroyInput.value = 1
        fieldWrapper.style.display = 'none'
      }
    }
  })
}
